/**
 * Находит размер в зависимости от масштаба
 */
export const scaleTransformFoo = (size: number, stageScale: number, factor: number = 0.5, planScale: number = 1) => {
    return size / stageScale ** factor;
};
